<template>
  <div
    ref="chart"
    style="height: 500px;"
  />
</template>

<script>
import echarts from 'echarts';

import { getProportionAnalysisTargetsList } from '../../config/';

const DEFAULT_TOTAL_SHOW = 15;

export default {
  props: {
    dataSource: {
      type: Array,
      default() {
        return [];
      },
    },

    dimension: {
      type: String,
      default: '',
    },

    target: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      chart: null,
      data: this.dataSource,
      targetList: getProportionAnalysisTargetsList(),
    };
  },

  watch: {
    dataSource(newVal) {
      this.data = newVal;
      this.render();
    },
  },

  methods: {
    render() {
      const targetName = this.getTargetData().label;
      const total = this.getTotal();

      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b} <br/>{a}: {c} ({d}%)',
        },
        legend: {
          orient: 'vertical',
          x: 'right',
          top: '25px',
        },
        series: [
          {
            name: targetName,
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center',
                formatter() {
                  return `总${targetName}\n\n${total}`;
                },
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '30',
                  fontWeight: 'bold',
                },
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: this.getSeriesData(),
          },
        ],
      };
      this.chart = echarts.init(this.$refs['chart']);
      this.chart.setOption(option);
    },

    getSeriesData() {
      const data = [];
      const len =
        this.data.length > DEFAULT_TOTAL_SHOW
          ? DEFAULT_TOTAL_SHOW
          : this.data.length;
      for (let i = 0; i < len; i += 1) {
        const item = this.data[i];
        data.push({
          value: item[this.target],
          name: item.dimension || '未知数据',
        });
      }
      // const data = this.data.map(item => ({
      //   value: item[this.target],
      //   name: item.dimension || '未知数据'
      // }));
      return data;
    },

    // 获取指标相关数据
    getTargetData() {
      const [target] = this.targetList.filter(
        (dim) => dim.value === this.target,
      );
      return target;
    },

    // 获取数据总量
    getTotal() {
      return this.data
        .reduce((prev, current) => {
          return prev + parseFloat(current[this.target]);
        }, 0)
        .toFixed(2);
    },
  },
};
</script>
